import { useState } from 'react';
import cookie from 'js-cookie';
import classNames from 'classnames';
import { t } from 'ttag';

import { FavoritesLikesPopup } from '@components/FavoritesLikesPopup';
import { SAVED_SEARCH_POPUP } from '@constants';
import StarIcon from '@svg/saved-star.svg';
import { useIsClient } from '@utils/common';

import s from './SavedSearchSubscribe.sss';

type SavedSearchSubscribeldProps = {
  onSavedSearch: () => void;
  onRemoveSavedSearch: () => void;
  isSaved: boolean;
  isSavedSearchTop?: boolean
};

export const SavedSearchSubscribe: React.FC<SavedSearchSubscribeldProps> = ({
  onSavedSearch,
  isSaved,
  onRemoveSavedSearch,
  isSavedSearchTop,
}) => {
  const isClient = useIsClient();
  const isFavoritePopupCookiesExist = cookie.get(SAVED_SEARCH_POPUP);

  const [openPopup, setOpenPopup] = useState(true);

  return (
    <>
      {!isSaved
        ? (
          <div
            className={classNames(
              s.root,
              s.savedSearchBlock, { [s.savedSearchTopBlock]: isSavedSearchTop },
            )}
            onClick={onSavedSearch}
          >
            <StarIcon className={classNames(
              s.icon, s.noMarked, { [s.savedSearchTopIcon]: isSavedSearchTop },
            )}
            />
            <p className={classNames(s.title, { [s.savedSearchTopTitle]: isSavedSearchTop })}>
              {t`Підписатися`}
            </p>
          </div>
        )
        : (
          <div
            className={classNames(
              s.root,
              s.savedSearchBlock, { [s.savedSearchTopBlock]: isSavedSearchTop },
            )}
            onClick={onRemoveSavedSearch}
          >
            <StarIcon className={s.icon} />
            <p className={classNames(s.title, { [s.savedSearchTopTitle]: isSavedSearchTop })}>
              {t`Ви підписані`}
            </p>
          </div>
        )}
      {isClient && !isFavoritePopupCookiesExist && isSavedSearchTop && openPopup && (
      <FavoritesLikesPopup
        cookieName={SAVED_SEARCH_POPUP}
        isSaved={true}
        text={t`Спробуйте підписатися на ці популярні пошукові запити`}
        isOpen={openPopup}
        onRequestClose={() => setOpenPopup(false)}
        className={s.favoriteLikesPopup}
      />
      )}
    </>
  );
};
